import { API_URL, ASSETS, URL, PLATFORM_FEE } from '../config.js';
import View from './View';

class SingleOrderView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'Single Order Payment View Error Message';
  _message = 'Single Order Payment View Success Message';

  addHandlerMakePayment(handler) {
    const paymentForm = document.querySelector('.make-payment-form');
    if (!paymentForm) return;

    paymentForm.addEventListener('submit', e => {
      e.preventDefault();
      e.stopImmediatePropagation();

      const dataArr = [...new FormData(paymentForm)];
      const data = Object.fromEntries(dataArr);

      handler(data.paymentOption);
    });
  }

  _generateMarkup() {
    const product = this._data;

    return `
      <div class="row cart">
        <div class="cart__head">
          <h2 class="cart__heading">Order Details</h2>
        </div>



        <!-- MANAGING CART ADDRESS AND PAYMENT -->
        <form action="#" class="cart__payment--container make-payment-form">
          <!-- SHIPPING ADDRESS -->
          <div class="cart__payment--address">
            <div class="cart__items--container-single">
              <ul class="cart__items">
                <li class="cart__item">

                  <a href="/product?${product.slug}" class="link">
                    <div class="cart__item--img">
                      <img
                        src="${ASSETS}images/product/${product.imageCover}"
                        alt="${product.tag}"
                      />
                    </div>
                  </a>
                  <div class="cart__item--detail">
                    <div class="">
                      <h3 class="cart__item--title">
                        ${product.brand}
                      </h3>
                      <h4 class="cart__item--tag">${product.tag}</h4>
                      <div class="product__size--button">
                        <button
                          class="product__size--btn product__size--btn-selected cart__size"
                          data-size="${product.size}"
                        >
                          ${product.size}
                        </button>
                      </div>
                    </div>

                    <div class="cart__item--price">
                      <span class="cart__item--discounted-price">₹ ${product.price}</span>
                      ${
                        product.mrp && product.mrp - product.price > 0
                          ? `<span class="cart__item--mrp">₹ ${product.mrp}</span> 
                      <span class="cart__item--discount-percent"
                        >(${Math.ceil(((product.mrp - product.price) * 100) / product.mrp)}% OFF)</span
                      >`
                          : ''
                      }
                      
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <h3 class="cart__payment--heading">Shipping Address</h3>

            <p class="paragraph">${product.shipAddress}</p>






          </div>

          <!-- AMOUNT DETAILS -->
          <div class="cart__detail">
            <div class="cart__price--container">
              <p class="cart__mrp--total cart__label-value">
                <span class="cart__mrp--total-label cart__label"
                  >Total MRP:</span
                ><span class="cart__mrp--total-value cart__value">₹${product.mrp}</span>
              </p>
              <p class="cart__discount--total cart__label-value">
                <span class="cart__discount--total-label cart__label"
                  >Discount on MRP:</span
                ><span class="cart__discount--total-value cart__value"
                  >${product.mrp - product.price > 0 ? `- ₹${product.mrp - product.price}` : `0`}</span
                >
              </p>
              ${
                product.platformFee
                  ? `<p class="cart__platformfee cart__label-value">
                <span class="cart__platformfee-label cart__label"
                  >Platform Fee:</span
                ><span class="cart__platformfee-value cart__value">₹${product.platformFee}</span>
              </p>`
                  : ``
              }

              ${
                product.tax
                  ? `<p class="cart__tax cart__label-value">
                <span class="cart__tax-label cart__label">Tax:</span
                ><span class="cart__tax-value cart__value">₹${product.tax}</span>
              </p>`
                  : ``
              }
          
              <p class="cart__price--total cart__label-value">
                <span class="cart__price--total-label">Total Amount:</span
                ><span class="cart__price--total-value"
                  ><strong>₹${Math.round(product.amount ? product.amount : product.price + +`${+(product.tax ? product.tax : 0)}` + +`${product.platformFee ? product.platformFee : 0}`)}</strong></span
                >
              </p>
            </div>

            <!-- PAYMENT OPTIONS -->



            <div class="cart__payment--options-container">
              <h3 class="product__spec--title cart__payment--method">Payment Method</h3>
              <ul class="cart__payment--options">

              ${
                product.payMethod === 'cod'
                  ? `
                <li class="cart__payment--option">
                  <input
                    type="radio"
                    name="paymentOption"
                    value="cod"
                    id="cod"
                    class="cart__payment--option-radio"
                    checked
                  />
                  <label for="cod">COD</label>
                </li>               
              `
                  : `
                <li class="cart__payment--option">
                  <input
                    type="radio"
                    name="paymentOption"
                    value="online"
                    id="online"
                    class="cart__payment--option-radio"
                    checked
                  />
                  <label for="online">UPI/CC/DC/NB</label>
                </li>              
              `
              }

                

              </ul>
            </div>

            <!-- CTA -->
            <div class="cart__cta--container">
              <div class="cart__cta">
                <button type="submit"
                  class="btn btn--cart cart__cta--btn cart__cta--btn-payment"
                >
                  Make Payment
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    `;
  }
}

export default new SingleOrderView();
